import React, { Component } from 'react';

import BackerAvatarItem from './BackerAvatarItem';
import UploadComponent from '../Util/Upload';
import { message } from 'antd';
import { Redirect } from 'react-router';

import Rocket from '../Icons/Rocket.svg';
import People from '../Icons/People.svg';
import iAdvizeLogo from '../Icons/iadvize-color.svg';
import Loader from '../Icons/Loader';

import './Project.css'

class Achieve extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
	    	files: [],
	    	isLoading:false,
	    	achieved:false,
	    	formRedirect:false,
	    	selectedOption: this.props.data.current_amount < 100 ? 'geniusPay' : ''
	    };
	    this.handleFileUploaded = this.handleFileUploaded.bind(this);
	    this.inputChange = this.inputChange.bind(this);
	    this.selectOption = this.selectOption.bind(this);
	}	

	componentDidMount(){
		window.scrollTo(0, 0);
	}

	handleFileUploaded(file){
		let newFiles = this.state.files;
		newFiles.push(file);
		this.setState({
	    	files: newFiles
	    })
	}

	inputChange(event){
		this.setState({
			[event.target.name]:event.target.value
		});
	}

	selectOption(option){
		this.setState({
			selectedOption:option
		});
	}

	achieveProject(){
		if(this.state.selectedOption === "iadvizePay" && this.state.files.length === 0){
			message.error('You have to upload the bill', 4);
			return
		}
		//SET PROJECT AN ACHIEVEMENT DATE
		let data = this.props.data;
		data.files = this.state.files;

		//WARN PEOPLE INVOLVED BY EMAIL
		let backersList = "";
		for(let i = 0; i < this.props.backers.length; i++){
			if(i === (this.props.backers.length - 1)){
				backersList += (this.props.backers[i].email);
			}else{
				backersList += (this.props.backers[i].email + ",");
			}
		}
		data.backersList = backersList;
		data.backers = this.props.backers;
		data.selectedOption = this.state.selectedOption;

		this.props.actions.achieveProject(data);

		message.success('Project achieved', 4);

		//DISPLAY THE REFUND DETAILS COMPONENT
		this.setState({
	    	achieved:true,
	    	formRedirect: true
	    })
	}

	render() {
		const createBackerAvatarItem = (item, index) => {
	    	return <BackerAvatarItem data={item} id={index} key={index} />
	    }
	    const getProgress = () => {
			let progressValue = 100 * this.props.data.current_amount / this.props.data.target;
			return ((progressValue > 100 ? 100 : progressValue) + '%');
		}
		return (
			<div>
				{ this.props.data &&
					<div className="container">
						<div className="achieveContainer">
							<div className="title-illu"><img src={Rocket} alt="Congratulations" /></div>
							<div className="title">Congratulations!</div>
							<div className="intro">Your project will be sheeped soon...but there's one last step!</div>
							<div className="infos-detail recap">
								<div className="bloc-title">Quick recap of your project</div>
								<div className="recap-content">
									<div className="infos">
										<div className="title">{this.props.data.title}</div>
										<div className="description">{this.props.data.description}</div>
										<div className="target"><span className="highlight">€{this.props.data.current_amount === null ? '0' : this.props.data.current_amount}</span> collected out of the <span className="highlight">€{this.props.data.target}</span> target</div>
										<div className="progression">
											<div className="progress" style={{'width':getProgress()}}></div>
										</div>
										<div className="backersAvatars">
											{this.props.backers.map(createBackerAvatarItem)}
										</div>
									</div>
								</div>
							</div>
							<div className="infos-detail expense">
								<div className="bloc-title">What you have to do to get a refund</div>
								<div className="bloc-content">
									{this.props.data.current_amount < 100 ?
										<div className="subtitle">
											The amount collected is under €100<br/>
											Here is the way to get your refund:
										</div>
										: 
										<div className="subtitle">
											The amount collected is above €100<br/>
											You have two options:
										</div>
									}
									<div className="bloc-options">
										<div className={"bloc-option geniuspay " + (this.state.selectedOption === "geniusPay" ? "selected" : '')}>
											<div className="title">Make an advance payment<br/>& declare an expense on Cleemy</div>
											<div className="illu"><img src={People} alt="I pay myself" /></div>
											<div className="suboption">
												<div className="description">
													As the project owner, it is your responsibility to advance the funds and declare your expense.
												</div>
											</div>
											<div className="description">
												To declare an expense in Cleemy, <a href="https://iadvize.ilucca.net/cleemy-Cleemy/expenses" target="_blank" rel="noopener noreferrer">click here</a>:
												<br/>
												1. Click on “Ajouter dépense”<br/>
												2. Select “Cagnotte” in the “Nature” section<br/>
												3. Fill up the amount you spent<br/>
												4. Upload the bill<br/>
												5. Put the ID of the project in the “Commentaire” section. 
												<div className="projectInfos">
													ID of the project:
													<div className="projectId">{this.props.data.project_id}</div>
												</div>
												<br/>
												IMPORTANT : Please declare the total amount of the project, not just the cost of your cagnotte.
											</div>
											{this.props.data.current_amount >= 100 &&
												<button className="button is-special" onClick={() => this.selectOption('geniusPay')}>Select this option</button>
											}
										</div>
										{this.props.data.current_amount >= 100 &&
											<div className="option-or"><div className="or-icon">OR</div></div>
										}
										{this.props.data.current_amount >= 100 &&
											<div className={"bloc-option iadvizepay " + (this.state.selectedOption === "iadvizePay" ? "selected" : '')}>
												<div className="title">Upload the bill<br/>& iAdvize will pay directly</div>
												<div className="illu"><img src={iAdvizeLogo} alt="iAdvize pay for you" /></div>
												<div className="description">
												Please take note that if you choose this option, the provider will receive the payment 45 days after the bill is received. Before you choose this option, please confirm this is ok with the provider.
												<br/><br/>
												So iAdvize can make this payment, please upload the bill here:
												</div>
												<div className="dropzone">
													<UploadComponent 
														data={this.props.data} 
														currentUser={this.props.currentUser} 
														handleFileUploaded={this.handleFileUploaded}
														message="Upload the bill here"
														type='bill' />
												</div>
												<button className="button is-special" onClick={() => this.selectOption('iadvizePay')}>Select this option</button>
											</div>
										}
									</div>
									<div className="actions">
										<div className="button is-abort" onClick={() => this.props.cancel()} >Cancel</div>
										<button className={"button is-primary " + (this.state.selectedOption === '' && 'is-inactive')} 
											disabled={this.state.selectedOption === ''} 
											onClick={() => this.achieveProject()}>
											{this.props.achieveProjectIsLoading ? 
												<Loader color="#fff" />
												: (
													"Sheep project"
													)
											}
										</button>

									</div>
								</div>
							</div>
						</div>
					</div>
				}
				{(this.props.formRedirect || this.state.formRedirect) &&
		          <Redirect to={'/yourprojects'}/>
		        }
			</div>
		);
	}
}

export default Achieve;



// WEBPACK FOOTER //
// ./src/components/Explore/Achieve.js